"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const debounce_1 = __importDefault(require("lodash/debounce"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const useThrottledResizeObserver_1 = __importDefault(require("./../../hooks/useThrottledResizeObserver"));
const useTable_1 = __importDefault(require("./../../hooks/useTable"));
const useLocalStorage_1 = __importDefault(require("../../hooks/useLocalStorage"));
const Table_styles_1 = require("./Table.styles");
const Header_1 = require("../Header");
const Body_1 = require("../Body");
const LoadingBody_1 = __importDefault(require("../LoadingBody"));
const Paginator_1 = __importDefault(require("../Paginator"));
const Filters_1 = __importStar(require("../Filters"));
const NoResultsBody_1 = __importDefault(require("../NoResultsBody"));
const ColumnToggle_1 = require("../ColumnToggle");
const usePrevious_1 = __importDefault(require("../../hooks/usePrevious"));
const useNormalizedRefs_1 = require("../../hooks/useNormalizedRefs");
const useScrollToTop_1 = require("../../hooks/useScrollToTop");
const ScrollToTop_1 = require("../ScrollToTop");
const AnnouncedSearchResultCount_1 = require("../AnnouncedSearchResultCount");
const DEFAULT_WAIT = 250;
/** A powerful component for rendering content within a table structure. */
const Table = (_a) => {
    var { id, columns, data, inline = false, fixed = false, isLoading = false, noResultsMessage = 'No results found', striped = false, disableHoverStyles = false, hideHeaderRow = false, rowStyles, rowClassNames, filterStyle, filterClassName, offsetTop = 0, onFetchData, sortProps, paginatorProps, filterProps, searchProps, columnToggleProps = false, rowSelectionProps = false, onRowClick, getRowId, skipFetchOnMount = false, scrollToTop = false, scrollToTopLabel, stateEventHandlers, ariaProps } = _a, restProps = __rest(_a, ["id", "columns", "data", "inline", "fixed", "isLoading", "noResultsMessage", "striped", "disableHoverStyles", "hideHeaderRow", "rowStyles", "rowClassNames", "filterStyle", "filterClassName", "offsetTop", "onFetchData", "sortProps", "paginatorProps", "filterProps", "searchProps", "columnToggleProps", "rowSelectionProps", "onRowClick", "getRowId", "skipFetchOnMount", "scrollToTop", "scrollToTopLabel", "stateEventHandlers", "ariaProps"]);
    const firstUpdate = react_1.default.useRef(true);
    const { ref: tableRef, width: tableWidth } = (0, useThrottledResizeObserver_1.default)({});
    const { ref: tableHeaderRef, height: tableHeaderHeight } = (0, useThrottledResizeObserver_1.default)({});
    const { ref: filterRef, height: filterHeight } = (0, useThrottledResizeObserver_1.default)({});
    const paginationDisabled = typeof paginatorProps === 'boolean' && !paginatorProps;
    const filtersDisabled = typeof filterProps === 'boolean' && !filterProps;
    const sortingDisabled = typeof sortProps === 'boolean' && !sortProps;
    const searchDisabled = typeof searchProps === 'boolean' && !searchProps;
    const columnToggleDisabled = typeof columnToggleProps === 'boolean' && !columnToggleProps;
    const [selectedRows, setSelectedRows] = react_1.default.useState({});
    const { onRowSelect = undefined } = typeof rowSelectionProps === 'boolean' && !rowSelectionProps
        ? {}
        : rowSelectionProps;
    const { label: columnToggleButtonLabel = undefined } = columnToggleDisabled
        ? {}
        : columnToggleProps;
    const columnsWithFilters = react_1.default.useMemo(() => filtersDisabled
        ? columns
        : Filters_1.filterUtils.augmentColumnsWithFilters(columns), [columns, filtersDisabled]);
    const tableData = react_1.default.useMemo(() => data, [data]);
    const defaultFilterTypes = react_1.default.useMemo(() => (filtersDisabled ? {} : Filters_1.filterUtils.getDefaultFilterTypes()), [filtersDisabled]);
    const defaultColumn = react_1.default.useMemo(() => ({
        minWidth: 30,
        width: 'auto'
    }), []);
    const [getHiddenTableColumns, useSetHiddenTableColumns] = (0, useLocalStorage_1.default)(`kyruus-table-${id !== null && id !== void 0 ? id : ''}`);
    const instance = (0, useTable_1.default)({
        columns: columnsWithFilters,
        data: tableData,
        defaultColumn,
        onFetchData,
        sortProps,
        paginatorProps,
        columnToggleProps,
        getHiddenTableColumns,
        filterProps: filtersDisabled
            ? {}
            : Object.assign(Object.assign({}, filterProps), { filterTypes: defaultFilterTypes }),
        searchProps: searchDisabled
            ? {}
            : Object.assign(Object.assign({}, searchProps), { filterTypes: defaultFilterTypes }),
        rowSelectionProps,
        getRowId,
        stateEventHandlers
    });
    const { getTableProps, allColumns, headerGroups, flatHeaders, getTableBodyProps, rows, prepareRow, page, headers, canPreviousPage, canNextPage, pageCount, gotoPage, nextPage, previousPage, setGlobalFilter, selectedFlatRows, showOutOf, totalCount, state: { pageIndex, pageSize, filters, sortBy, globalFilter, selectedRowIds } } = instance;
    const allToggleableColumns = onRowSelect ? allColumns.slice(1) : allColumns;
    const hiddenColumnHeaders = react_1.default.useMemo(() => columnToggleDisabled
        ? undefined
        : headers
            .filter((header) => !header.isVisible)
            .map((header) => header.id), [columnToggleDisabled, headers]);
    useSetHiddenTableColumns(hiddenColumnHeaders);
    const onFetchDataDebounced = react_1.default.useRef((0, debounce_1.default)(({ pageIndex, pageSize, filters, sortBy, searchBy, totalCount }) => __awaiter(void 0, void 0, void 0, function* () {
        if (onFetchData != null) {
            yield onFetchData({
                currentPage: pageIndex,
                pageSize: pageSize,
                filters: filters,
                sortBy: sortBy,
                searchBy: searchBy,
                totalCount: totalCount
            });
        }
    }), DEFAULT_WAIT));
    react_1.default.useEffect(() => {
        var _a;
        if (firstUpdate.current) {
            firstUpdate.current = false;
            if (skipFetchOnMount)
                return;
        }
        if (onFetchData != null &&
            onFetchDataDebounced &&
            onFetchDataDebounced.current) {
            onFetchDataDebounced.current({
                pageIndex,
                pageSize,
                filters,
                sortBy,
                searchBy: globalFilter,
                totalCount
            });
        }
        return (_a = onFetchDataDebounced.current) === null || _a === void 0 ? void 0 : _a.cancel;
    }, [
        onFetchData,
        onFetchDataDebounced,
        pageIndex,
        pageSize,
        filters,
        sortBy,
        globalFilter,
        totalCount,
        skipFetchOnMount
    ]);
    const prevSelectedRowIds = (0, usePrevious_1.default)(selectedRowIds);
    react_1.default.useEffect(() => {
        if (onRowSelect) {
            // react-table does not track selected rows across pages when working with server-side data
            // instead we must track those rows ourselves
            let newSelectedRows = {};
            if (!(0, isEqual_1.default)(prevSelectedRowIds, selectedRowIds)) {
                Object.values(selectedRows).forEach((row) => {
                    if (selectedRowIds[row.id]) {
                        newSelectedRows = Object.assign(Object.assign({}, newSelectedRows), { [row.id]: row });
                    }
                });
                selectedFlatRows.forEach((row) => {
                    if (selectedRowIds[row.id]) {
                        newSelectedRows = Object.assign(Object.assign({}, newSelectedRows), { [row.id]: row });
                    }
                });
                setSelectedRows(newSelectedRows);
                onRowSelect(Object.values(newSelectedRows) || [], selectedRowIds || {});
            }
        }
    }, [
        onRowSelect,
        prevSelectedRowIds,
        selectedFlatRows,
        selectedRowIds,
        selectedRows
    ]);
    const hasFiltersAbove = flatHeaders.some((column) => column.canFilter && column.Filter && column.filterLocation === 'above');
    const filterTop = offsetTop || 0;
    const tableTop = (filterHeight || 0) + (offsetTop || 0);
    const bodyTop = tableTop + (tableHeaderHeight || 0);
    const { tableRef: scrollToTopTableRef, topRowRef: scrollToTopTopRowRef, showScrollToTop } = (0, useScrollToTop_1.useScrollToTop)({ tableTop, skip: scrollToTop !== 'user' });
    const finalTableRef = (0, useNormalizedRefs_1.useNormalizedRefs)(tableRef, scrollToTopTableRef);
    const wrapperRef = react_1.default.useRef(null);
    const tableOptionsDisabled = (filtersDisabled || !hasFiltersAbove) &&
        searchDisabled &&
        columnToggleDisabled;
    const showPaginatorOutOf = onFetchData == null && !(0, isEmpty_1.default)(filters) ? false : showOutOf;
    const pageOrRows = page || rows;
    const activelySearching = !(0, isEmpty_1.default)(globalFilter) || !(0, isEmpty_1.default)(filters);
    const totalRowCount = activelySearching === false && paginatorProps
        ? paginatorProps === null || paginatorProps === void 0 ? void 0 : paginatorProps.totalCount
        : rows.length;
    react_1.default.useEffect(() => {
        var _a;
        if (scrollToTop === 'state') {
            (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }, [pageOrRows, scrollToTop]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Table_styles_1.TableWrapper, { ref: wrapperRef, inline: inline, "data-testid": "table-wrapper", style: scrollToTop ? { scrollMarginTop: `${tableTop}px` } : undefined },
            react_1.default.createElement(AnnouncedSearchResultCount_1.AnnouncedSearchResultCount, { ariaLiveLabel: ariaProps === null || ariaProps === void 0 ? void 0 : ariaProps.ariaLiveLabel, searching: activelySearching, count: totalRowCount || 0 }),
            showScrollToTop && (react_1.default.createElement(ScrollToTop_1.ScrollToTop, { bodyTop: bodyTop, scrollToTopLabel: scrollToTopLabel, onScroll: () => {
                    var _a;
                    (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                } })),
            tableOptionsDisabled ? null : (react_1.default.createElement(Table_styles_1.TableOptionsWrapper, { className: filterClassName, style: filterStyle, width: tableWidth, filterTop: filterTop, ref: filterRef },
                filtersDisabled || !hasFiltersAbove ? null : (react_1.default.createElement(Filters_1.default, { "data-testid": "filters-container", headers: flatHeaders, tableId: id, isLoading: isLoading })),
                react_1.default.createElement(Table_styles_1.ColumnToggleSearchWrapper, null,
                    !columnToggleDisabled && (react_1.default.createElement(ColumnToggle_1.ColumnToggleContainer, { tableId: id, columns: allToggleableColumns, buttonLabel: columnToggleButtonLabel })),
                    searchDisabled ? null : (react_1.default.createElement(Filters_1.GlobalSearch, Object.assign({ tableId: id }, searchProps, { searchBy: globalFilter, setSearchBy: setGlobalFilter })))))),
            react_1.default.createElement(Table_styles_1.StyledTable, Object.assign({ "data-testid": "table" }, getTableProps(), { id: id, fixed: fixed }, restProps, { ref: finalTableRef }),
                !hideHeaderRow ? (react_1.default.createElement(Header_1.Header, { ref: tableHeaderRef, tableId: id, "data-testid": "header", tableTop: tableTop, fixed: fixed, headerGroups: headerGroups, isLoading: isLoading, filtersDisabled: filtersDisabled, sortingDisabled: sortingDisabled })) : (react_1.default.createElement("thead", null)),
                isLoading ? (react_1.default.createElement(LoadingBody_1.default, { "data-testid": "loading-body", columns: allColumns, pageSize: pageSize, hideHeaderRow: hideHeaderRow })) : (0, isEmpty_1.default)(page || rows) ? (react_1.default.createElement(NoResultsBody_1.default, { "data-testid": "no-results-body", isFiltered: activelySearching, numColumns: allColumns.length, noResultsMessage: noResultsMessage })) : (react_1.default.createElement(Body_1.Body, Object.assign({ ref: scrollToTopTopRowRef, "data-testid": "body", disableHoverStyles: disableHoverStyles, hideHeaderRow: hideHeaderRow, striped: striped, rows: pageOrRows, prepareRow: prepareRow, rowStyles: rowStyles, rowClassNames: rowClassNames, onRowClick: onRowClick }, getTableBodyProps())))),
            paginationDisabled ? null : (react_1.default.createElement(Paginator_1.default, Object.assign({ "data-testid": "paginator" }, paginatorProps, { isLoading: isLoading, pageCount: pageCount, currentPage: pageIndex, hasNextPage: canNextPage, hasPreviousPage: canPreviousPage, goToPage: gotoPage, nextPage: nextPage, previousPage: previousPage, showOutOf: showPaginatorOutOf, totalCount: totalRowCount, pageSize: pageSize }))))));
};
exports.default = Table;
//# sourceMappingURL=Table.js.map